import { render, staticRenderFns } from "./CultureAboutJinqiaoType.vue?vue&type=template&id=530c59ba&scoped=true&"
import script from "./CultureAboutJinqiaoType.vue?vue&type=script&lang=js&"
export * from "./CultureAboutJinqiaoType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c59ba",
  null
  
)

export default component.exports